import { render } from "./ResearchItsIntroComp.vue?vue&type=template&id=40b20dd2&scoped=true"
import script from "./ResearchItsIntroComp.vue?vue&type=script&lang=js"
export * from "./ResearchItsIntroComp.vue?vue&type=script&lang=js"

import "./ResearchItsIntroComp.vue?vue&type=style&index=0&id=40b20dd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b20dd2"]])

export default __exports__